import {required} from "../../../../../../../shared/utils/forms/utils/validationType";

export const useValidationLOX_POC_TOC_COX = (t: any, dataForm: any) => {
    const lox = [
        {
            name: "pathology",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("common.pathologies")
                    }
                }
            ]
        },
        {
            name: "flow_night_LOX",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.nightFlow")
                    }
                }
            ]
        },
        {
            name: "flow_rest_LOX",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.flowRest")
                    }
                }
            ]
        },
        {
            name: "flow_underStress_LOX",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.underStressFlow")
                    }
                }
            ]
        },
        {
            name: "validUntil",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.validUntil")
                    }
                }
            ]
        },
    ];
    const toc = [
        {
            name: "pathology",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("common.pathologies")
                    }
                }
            ]
        },
        {
            name: "flow_night_TOC",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.nightFlow")
                    }
                }
            ]
        },
        {
            name: "flow_rest_TOC",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.flowRest")
                    }
                }
            ]
        },
        {
            name: "flow_underStress_TOC",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.underStressFlow")
                    }
                }
            ]
        },
        {
            name: "validUntil",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.validUntil")
                    }
                }
            ]
        },
    ];
    const poc = [
        {
            name: "pathology",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("common.pathologies")
                    }
                }
            ]
        },
        {
            name: "level_night_POC",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.nightLevel")
                    }
                }
            ]
        },
        {
            name: "level_rest_POC",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.levelRest")
                    }
                }
            ]
        },
        {
            name: "level_underStress_POC",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.underStressLevel")
                    }
                }
            ]
        },
        {
            name: "validUntil",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.validUntil")
                    }
                }
            ]
        },
    ];
    const cox = [
        {
            name: "pathology",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("common.pathologies")
                    }
                }
            ]
        },
        {
            name: "flow_night_COX",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.nightFlow")
                    }
                }
            ]
        },
        {
            name: "flow_rest_COX",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.flowRest")
                    }
                }
            ]
        },
        {
            name: "flow_underStress_COX",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.underStressFlow")
                    }
                }
            ]
        },
        {
            name: "validUntil",
            validations: [
                {
                    name: required,
                    params: {
                        name: t("prescription.template.validUntil")
                    }
                }
            ]
        },
    ];

    return {lox, toc, poc, cox};

};
